export const GET_CURRENT_ARCADE = 'arcade/GET_CURRENT_ARCADE';
export const UPDATE_ARCADE_BY_ID = 'arcade/UPDATE_ARCADE_BY_ID';
export const UPDATE_ARCADE_STATUS = 'arcade/UPDATE_ARCADE_STATUS';
export const CREATE_ARCADE_MODULE = 'arcade/CREATE_ARCADE_MODULE';
export const REMOVE_ARCADE_MODULE_BY_ID = 'arcade/REMOVE_ARCADE_MODULE_BY_ID';
export const UPDATE_ARCADE_MODULE_BY_ID = 'arcade/UPDATE_ARCADE_MODULE_BY_ID';
export const REORDER_ARCADE_LESSONS = 'arcade/REODER_ARCADE_LESSONS';
export const REORDER_ARCADE_MODULES = 'arcade/REORDER_ARCADE_MODULES';
